import { capitalize } from 'lodash';
import { useMemo } from 'react';
import { Variant } from 'molecules/VariantList/types';
import {
  IAdaptedBasicProduct,
  IAdaptedProduct,
} from 'commerce/scayle/utils/adapter/types';

export const useVariantsWithProduct: (product: IAdaptedProduct) => Variant[] = (
  product,
) => {
  const getProductVariantData = (item: IAdaptedBasicProduct) => {
    const colorValues = item.colors
      ?.map((color) => capitalize(String(color?.label)))
      .join(' / ');

    return {
      id: item.id,
      cover: item.coverImage,
      href: item.href,
      colors: item.colors,
      title: colorValues,
      isActive: item.isActive,
      isSoldOut: item.isSoldOut,
      referenceKey: item.referenceKey,
    };
  };

  return useMemo(() => {
    const productData = getProductVariantData(product);
    const siblingsData = product.siblings?.map(getProductVariantData) || [];
    return [productData, ...siblingsData];
  }, [product]);
};
